import { createBrowserRouter } from "react-router";

import { checkDefaultTheme } from "@/utils";

import { DashboardLayout, HomeLayout } from "@/layouts";
import { dashboardLoader } from "@/layouts/dashboard-layout";

import { Error } from "@/pages";
import { statsLoader } from "@/pages/stats";
import { loginAction } from "@/pages/login";
import { adminLoader } from "@/pages/admin";
import { addJobAction } from "@/pages/add-job";
import { profileAction } from "@/pages/profile";
import { allJobsLoader } from "@/pages/all-jobs";
import { registerAction } from "@/pages/register";
import { deleteJobAction } from "@/pages/delete-job";
import { editJobAction, editJobLoader } from "@/pages/edit-job";

const isDarkThemeEnabled = checkDefaultTheme();

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomeLayout />,
    errorElement: <Error />,
    children: [
      {
        index: true,
        async lazy() {
          const { Landing } = await import("@/pages");
          return { Component: Landing };
        },
      },
      {
        path: "login",
        async lazy() {
          const { Login } = await import("@/pages");
          return { Component: Login, action: loginAction };
        },
      },
      {
        path: "register",
        async lazy() {
          const { Register } = await import("@/pages");
          return { Component: Register, action: registerAction };
        },
      },
      {
        path: "dashboard",
        element: <DashboardLayout isDarkThemeEnabled={isDarkThemeEnabled} />,
        loader: dashboardLoader,
        children: [
          {
            index: true,
            async lazy() {
              const { AddJob } = await import("@/pages");
              return { Component: AddJob, action: addJobAction };
            },
          },
          {
            path: "admin",
            async lazy() {
              const { Admin } = await import("@/pages");
              return { Component: Admin, loader: adminLoader };
            },
          },
          {
            path: "all-jobs",
            async lazy() {
              const { AllJobs } = await import("@/pages");
              return { Component: AllJobs, loader: allJobsLoader };
            },
          },
          {
            path: "stats",
            async lazy() {
              const { Stats } = await import("@/pages");
              return { Component: Stats, loader: statsLoader };
            },
          },
          {
            path: "profile",
            async lazy() {
              const { Profile } = await import("@/pages");
              return { Component: Profile, action: profileAction };
            },
          },
          {
            path: "edit-job/:id",
            async lazy() {
              const { EditJob } = await import("@/pages");
              return { Component: EditJob, action: editJobAction, loader: editJobLoader };
            },
          },
          {
            path: "delete-job/:id",
            action: deleteJobAction,
          },
        ],
      },
    ],
  },
]);

export default router;
